var baseUrl = 'https://docs.sanity.io/help/'

module.exports = function generateHelpUrl(slug) {
  return baseUrl + slug
}



//////////////////
// WEBPACK FOOTER
// ./~/@sanity/client/~/@sanity/generate-help-url/index.js
// module id = 275
// module chunks = 0